import "./navbar.scss";
import { useContext, useEffect, useState } from "react";
import { DarkModeContext } from "../../context/darkModeContext";
import { AuthContext } from "../../context/AuthContext";
import { database } from "../../firebase";
import { ref, onValue, update, off, push, get } from "firebase/database";
import LoginTermsAndCondition from "../../pages/Modals/LoginTermsAndConditions";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
} from "@mui/material";

const NavbarForRole7 = () => {
  const { dispatch } = useContext(DarkModeContext);
  const { currentUser } = useContext(AuthContext);
  const [openDialog, setOpenDialog] = useState(false);
  const [redirectDialogOpen, setRedirectDialogOpen] = useState(false);
  const [customUrl, setCustomUrl] = useState("");
  const [tabletBlockMessage, setTabletBlockMessage] = useState("");

  // Utility to detect tablet device
  const isTablet = () => {
    const width = window.innerWidth;
    return width >= 768 && width <= 1024;
  };

  // Terms and Conditions Check
  useEffect(() => {
    if (currentUser) {
      const userRef = ref(database, `users/${currentUser.uid}/isTermsAccepted`);
      onValue(userRef, (snapshot) => {
        const isTermsAccepted = snapshot.val();
        if (isTermsAccepted !== true) {
          setOpenDialog(true);
        }
      });

      return () => {
        off(userRef);
      };
    }
  }, [currentUser]);

  const handleTermsAccept = () => {
    if (currentUser) {
      const userRef = ref(database, `users/${currentUser.uid}`);
      const timestamp = new Date().toISOString();

      update(userRef, {
        isTermsAccepted: true,
        termsAcceptanceDate: timestamp,
      }).then(() => {
        const logRef = ref(
          database,
          `/logs/TermsAndConditionsLog/${currentUser.companyId}/${currentUser.uid}/loginTerms/`
        );
        const newLogRef = push(logRef);
        const termsId = newLogRef.key;

        update(newLogRef, {
          termsId,
          companyId: currentUser.companyId || "Unknown",
          email: currentUser.email || "No Email",
          fullName: currentUser.displayName || "No Name",
          message: "User accepted login terms and conditions.",
          timestamp,
          userId: currentUser.uid,
        });

        setOpenDialog(false);
      });
    }
  };

  const handleRedirectConfirm = () => {
    if (customUrl) {
      window.location.href = `/customurl/${customUrl}`;
    }
  };
  
  // Tablet detection and logic

  return (
    <div className="navbar">
      <div className="wrapper">
        <div className=""></div>
        <div className="items">
          <div className="item">
            {currentUser
              ? currentUser.displayName || currentUser.email
              : "Guest"}
          </div>
        </div>
      </div>

      {/* Terms and Conditions Modal */}
      <Dialog open={openDialog} disableEscapeKeyDown>
        <DialogTitle>Terms and Conditions</DialogTitle>
        <DialogContent>
          <LoginTermsAndCondition onAccept={handleTermsAccept} />
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default NavbarForRole7;
